(function () {
  function init(root) {
    if (!root || root.dataset.wdFaqInit === '1') return;
    root.dataset.wdFaqInit = '1';

    const detailsList = () => Array.from(root.querySelectorAll('.wd-faq__details'));

    root.addEventListener('toggle', function (e) {
      const t = e.target;
      if (!t || !t.classList || !t.classList.contains('wd-faq__details')) return;
      if (!t.open) return;
      detailsList().forEach(function (d) {
        if (d !== t && d.open) d.open = false;
      });
    });
  }

  document.querySelectorAll('[data-wd-faq-root]').forEach(init);

  document.addEventListener('shopify:section:load', function (ev) {
    const sec = ev.target;
    if (!sec || !sec.querySelectorAll) return;
    sec.querySelectorAll('[data-wd-faq-root]').forEach(init);
    sec.querySelectorAll('[data-wd-faq-contact-dialog]').forEach(bindContactDialog);
  });

  /** --- Contact CTA → modal (Section Rendering API) --- */
  function stripScriptsFromHtml(html) {
    try {
      const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
      doc.querySelectorAll('script').forEach(function (s) {
        s.remove();
      });
      return doc.body ? doc.body.innerHTML : '';
    } catch (e) {
      return String(html || '');
    }
  }

  function hasContactFormScript() {
    return Array.from(document.scripts).some(function (s) {
      return s.src && s.src.indexOf('wd-contact-form.js') !== -1;
    });
  }

  function ensureContactFormScript(src, done) {
    if (hasContactFormScript()) {
      done();
      return;
    }
    if (!src) {
      done();
      return;
    }
    const s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.onload = function () {
      done();
    };
    s.onerror = function () {
      done();
    };
    document.head.appendChild(s);
  }

  function setContactModalState(dialog, state) {
    const loading = dialog.querySelector('[data-wd-faq-contact-loading]');
    const errBox = dialog.querySelector('[data-wd-faq-contact-error]');
    const errMsg = dialog.querySelector('[data-wd-faq-contact-error-msg]');
    if (loading) loading.classList.toggle('hidden', state !== 'loading');
    if (errBox) errBox.classList.toggle('hidden', state !== 'error');
    if (state === 'error' && errMsg) {
      errMsg.textContent = dialog.getAttribute('data-wd-faq-modal-err') || '';
    }
  }

  /** Same-origin path+search+hash only; rejects cross-origin, invalid URL, or empty input (no passthrough). */
  function sameOriginPathOnly(urlStr) {
    try {
      var s = String(urlStr != null ? urlStr : '').trim();
      if (!s) return null;
      var u = new URL(s, window.location.href);
      if (u.origin !== window.location.origin) return null;
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return null;
    }
  }

  function appendPreviewThemeId(urlStr) {
    if (urlStr == null) return null;
    try {
      var cur = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (!cur) return urlStr;
      var u = new URL(urlStr, window.location.href);
      if (u.origin !== window.location.origin) return null;
      u.searchParams.set('preview_theme_id', cur);
      return u.pathname + u.search + u.hash;
    } catch (e2) {
      return null;
    }
  }

  /** Shopify Section Rendering expects locale-prefixed paths when markets/languages use them (see Shopify.routes / FoxTheme.routes.root_url). */
  function localeRootPathname() {
    var r = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.root_url) || '/';
    try {
      var p = new URL(r, window.location.href).pathname;
      if (p === '/') return '/';
      return p.replace(/\/+$/, '') || '/';
    } catch (e) {
      return '/';
    }
  }

  function applyLocaleRootToPath(path) {
    if (!path || !String(path).trim()) return path;
    try {
      var u = new URL(path, window.location.href);
      var locRoot = localeRootPathname();
      var pn = u.pathname;
      if (locRoot === '/' || locRoot === '') return u.pathname + u.search + u.hash;
      if (pn === locRoot || pn.indexOf(locRoot + '/') === 0) return u.pathname + u.search + u.hash;
      u.pathname = locRoot + (pn.charAt(0) === '/' ? pn : '/' + pn);
      return u.pathname + u.search + u.hash;
    } catch (e2) {
      return path;
    }
  }

  function buildSectionRenderUrl(base, sectionKey) {
    var path = sameOriginPathOnly(String(base || '').trim());
    if (path == null) return null;
    path = appendPreviewThemeId(path);
    if (path == null) return null;
    var sep = path.indexOf('?') === -1 ? '?' : '&';
    return path + sep + 'sections=' + encodeURIComponent(sectionKey);
  }

  function escapeRegExp(s) {
    return String(s || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /**
   * Section Rendering JSON may key HTML by the JSON template key (e.g. form_contact)
   * or by the rendered id (template--123__form_contact). Accept either.
   */
  function pickSectionHtml(json, sectionKey) {
    if (!json || !sectionKey) return null;
    var pools = [];
    if (json.sections && typeof json.sections === 'object') pools.push(json.sections);
    pools.push(json);
    var sk = String(sectionKey);
    var dynRe = new RegExp('^template--\\d+__' + escapeRegExp(sk) + '$');
    for (var pi = 0; pi < pools.length; pi++) {
      var obj = pools[pi];
      var html = obj[sk];
      if (typeof html === 'string' && html.length > 0) return html;
      for (var k in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
        if (dynRe.test(k)) {
          html = obj[k];
          if (typeof html === 'string' && html.length > 0) return html;
        }
      }
    }
    return null;
  }

  function extractRenderedSectionIdFromMarkup(pageHtml, jsonSectionKey) {
    if (!pageHtml || !jsonSectionKey) return null;
    var re = new RegExp(
      'id=["\']shopify-section-(template-\\d+__' + escapeRegExp(String(jsonSectionKey)) + ')["\']',
      'i'
    );
    var m = String(pageHtml).match(re);
    return m ? m[1] : null;
  }

  /** When ?sections= returns null, use SSR markup from the contact page (same as visiting the page). */
  function extractSectionOuterHtmlFromFullPage(pageHtml, jsonSectionKey) {
    if (!pageHtml || !jsonSectionKey) return null;
    try {
      var doc = new DOMParser().parseFromString(String(pageHtml), 'text/html');
      var suf = '__' + String(jsonSectionKey);
      var nodes = doc.querySelectorAll('[id^="shopify-section-"]');
      for (var i = 0; i < nodes.length; i++) {
        var sid = nodes[i].getAttribute('id') || '';
        if (sid.length > suf.length && sid.slice(-suf.length) === suf) {
          return nodes[i].outerHTML;
        }
      }
      var staticWrap = doc.getElementById('shopify-section-' + jsonSectionKey);
      return staticWrap ? staticWrap.outerHTML : null;
    } catch (e) {
      return null;
    }
  }

  function modalFetchBasePath(dialog) {
    var b = dialog.getAttribute('data-wd-faq-modal-src');
    var t = String(b || '').trim();
    if (!t) return '';
    var rel = sameOriginPathOnly(t);
    rel = applyLocaleRootToPath(rel);
    return appendPreviewThemeId(rel);
  }

  function fetchSectionRenderJson(path, sectionParam) {
    var url = buildSectionRenderUrl(path, sectionParam);
    if (url == null) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[wd-section-product-faq] Refused to fetch: modal base URL is not same-origin or invalid.');
      }
      return Promise.reject(new Error('blocked'));
    }
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (r) {
      if (!r.ok) throw new Error('bad status');
      return r.json();
    });
  }

  function fetchModalPageHtml(path) {
    if (path == null || String(path).trim() === '') {
      return Promise.reject(new Error('blocked'));
    }
    return fetch(path, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html,application/xhtml+xml;q=0.9,*/*;q=0.8',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (r) {
      if (!r.ok) throw new Error('bad status');
      return r.text();
    });
  }

  function loadContactIntoDialog(dialog) {
    const sectionKey = dialog.getAttribute('data-wd-faq-modal-section');
    const body = dialog.querySelector('[data-wd-faq-contact-dialog-body]');
    const jsSrc = dialog.getAttribute('data-wd-contact-form-js');
    const basePath = modalFetchBasePath(dialog);
    if (!basePath || !sectionKey || !body) return Promise.reject(new Error('missing'));

    function applySectionHtml(html) {
      body.innerHTML = stripScriptsFromHtml(html);
      return new Promise(function (resolve) {
        ensureContactFormScript(jsSrc, function () {
          document.dispatchEvent(
            new CustomEvent('wd:contact-form-init', {
              detail: { root: body },
            })
          );
          resolve();
        });
      });
    }

    return fetchSectionRenderJson(basePath, sectionKey)
      .then(function (json) {
        var html = pickSectionHtml(json, sectionKey);
        if (html) return html;
        return fetchModalPageHtml(basePath).then(function (pageHtml) {
          var fromPage = extractSectionOuterHtmlFromFullPage(pageHtml, sectionKey);
          if (fromPage) return fromPage;
          var dyn = extractRenderedSectionIdFromMarkup(pageHtml, sectionKey);
          if (!dyn) throw new Error('no section');
          return fetchSectionRenderJson(basePath, dyn).then(function (json2) {
            var html2 = pickSectionHtml(json2, sectionKey);
            if (!html2) throw new Error('no section');
            return html2;
          });
        });
      })
      .then(applySectionHtml);
  }

  function trapDialogFocus(dialog) {
    const panel = dialog.querySelector('.wd-faq__contact-dialog-panel');
    const closeBtn = dialog.querySelector('[data-wd-faq-contact-close]');
    const focusable = panel
      ? panel.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      : null;
    try {
      dialog.focus();
    } catch (e) {
      try {
        (closeBtn || focusable || dialog).focus();
      } catch (e2) {
        /* ignore */
      }
    }
  }

  function bindContactDialog(dialog) {
    if (!dialog || dialog.dataset.wdFaqContactBound === '1') return;
    dialog.dataset.wdFaqContactBound = '1';

    const closeBtn = dialog.querySelector('[data-wd-faq-contact-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        try {
          dialog.close();
        } catch (e) {
          dialog.removeAttribute('open');
        }
      });
    }

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) {
        try {
          dialog.close();
        } catch (e2) {
          dialog.removeAttribute('open');
        }
      }
    });
  }

  function openContactDialog(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') {
      const href = dialog && dialog.getAttribute('data-wd-faq-fallback-href');
      if (href) window.location.href = href;
      return;
    }

    bindContactDialog(dialog);

    const run = function () {
      try {
        dialog.showModal();
      } catch (e) {
        const href = dialog.getAttribute('data-wd-faq-fallback-href');
        if (href) window.location.href = href;
        return;
      }
      trapDialogFocus(dialog);
    };

    if (dialog.dataset.wdFaqContactLoaded === '1') {
      run();
      return;
    }

    setContactModalState(dialog, 'loading');
    loadContactIntoDialog(dialog)
      .then(function () {
        dialog.dataset.wdFaqContactLoaded = '1';
        setContactModalState(dialog, 'ready');
        run();
      })
      .catch(function () {
        setContactModalState(dialog, 'error');
        try {
          dialog.showModal();
        } catch (e2) {
          const href = dialog.getAttribute('data-wd-faq-fallback-href');
          if (href) window.location.href = href;
        }
        trapDialogFocus(dialog);
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      const a = e.target && e.target.closest && e.target.closest('a[data-wd-faq-cta-mode="modal"]');
      if (!a) return;
      const id = a.getAttribute('data-wd-faq-contact-dialog-id');
      if (!id) return;
      const dialog = document.getElementById(id);
      if (!dialog) return;
      e.preventDefault();
      openContactDialog(dialog);
    },
    true
  );

  document.querySelectorAll('[data-wd-faq-contact-dialog]').forEach(bindContactDialog);
})();
